import { Chip, Stack } from "@mui/material";
import { useRecordContext } from "react-admin";
import type { ProviderStatus } from "../../../types/api";

const getStatusColor = (status: ProviderStatus) => {
  switch (status) {
    case "active":
      return "success";
    case "inactive":
      return "default";
    case "maintenance":
      return "warning";
    case "deprecated":
      return "error";
    default:
      return "default";
  }
};

const getStatusLabel = (status: ProviderStatus) =>
  status.charAt(0).toUpperCase() + status.slice(1);

export const ProviderStatusChip = () => {
  const record = useRecordContext();
  if (!record) return null;

  // production/development are per-environment summaries from the backend;
  // fall back to the flat status field (older API shape / no rules row yet).
  const prodStatus = (record.production?.status ??
    record.status) as ProviderStatus;
  const devStatus = (record.development?.status ??
    record.status) as ProviderStatus;

  return (
    <Stack direction="row" spacing={0.5}>
      <Chip
        label={`Prod: ${getStatusLabel(prodStatus)}`}
        color={getStatusColor(prodStatus)}
        size="small"
      />
      <Chip
        label={`Dev: ${getStatusLabel(devStatus)}`}
        color={getStatusColor(devStatus)}
        size="small"
        variant="outlined"
      />
    </Stack>
  );
};
